module.exports = __webpack_public_path__ + "img/PY.c6dfc9d5.svg";